import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card } from "react-bootstrap";
import Loader from "../components/Loader";
import Message from "../components/Message";
import backend from "../api";

const MyTransactions = () => {
  const [wallets, setWallets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin; 

  useEffect(() => {
    const fetchWallets = async () => {

      try {
        const response = await backend.get("/eMoney-userwallet/wallet", {
          params: { ownerId: userInfo.user._id }, 
        });

        if (response.data.success) {
            console.log(response.data.data)
          setWallets(response.data.data);
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        setError("Error fetching wallets");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchWallets();
  }, [userInfo]);

  return (
    <Card>
      {loading ? (
        <div className="mt-3">
          <div className="my-5 row justify-content-center">
            <Loader />
          </div>
        </div>
      ) : error ? (
        <div className="mt-3">
          <div className="my-5 row justify-content-center">
            <Message variant="danger">{error}</Message>
          </div>
        </div>
      ) : (
        <div className="mt-3">
          <div>
            <div className="mx-3">
              <h3>Wallet Transactions</h3>
            </div>
            <div className="row mt-3">
              <div className="col-lg-12 mx-auto">
                {wallets.map((wallet) => (
                  <div className="mt-3" key={wallet._id}>
                    <div className="row">
                      <div className="col-lg-12 px-5">
                        <div>
                          <h4>
                            <span>
                            Transaction Number &mdash; <b>{wallet.transaction_number}</b>
                            </span>
                          </h4>
                          <span>Amount &mdash; ${wallet.amount.toFixed(2)}</span>
                        </div>
                        <div>
                          <h6 className="mb-2 d-flex justify-content-between">
                          <small>
                              Transaction Type &mdash; {wallet.transaction_type}
                              <br />
                              Transaction Date &mdash;{" "}
                              {new Date(wallet.transaction_date).toLocaleDateString()}
                            </small>
                          </h6>
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
};

export default MyTransactions;
